"use client"

import { RarityFilterOption } from "@anaconda/core/nft/search/types"
import { Trans } from "@lingui/react/macro"
import {
  Label,
  RadioGroup,
  RadioGroupItem,
} from "@rarible_int/anaconda_ui_components"
import { reatomComponent } from "@reatom/react"
import { useMolecule } from "bunshi/react"
import { NftFiltersMoleculeReatom } from "./store.reatom"

const FILTER_OPTIONS = [
  { type: RarityFilterOption.ALL, label: <Trans>All</Trans> },
  { type: RarityFilterOption.TOP_1_PERCENT, label: <Trans>Top 1%</Trans> },
  { type: RarityFilterOption.TOP_10_PERCENT, label: <Trans>Top 10%</Trans> },
  { type: RarityFilterOption.TOP_25_PERCENT, label: <Trans>Top 25%</Trans> },
] as const

export const RarityFilter = reatomComponent(() => {
  const { rarityFilter } = useMolecule(NftFiltersMoleculeReatom)
  const rarity = rarityFilter()

  return (
    <RadioGroup
      className="flex flex-col gap-3"
      value={rarity ?? RarityFilterOption.ALL}
      onValueChange={(value) => rarityFilter.set(value as RarityFilterOption)}
    >
      {FILTER_OPTIONS.map(({ type, label }) => (
        <div key={type} className="flex items-center gap-3">
          <RadioGroupItem value={type} id={type} />
          <Label className="cursor-pointer text-md" htmlFor={type}>
            {label}
          </Label>
        </div>
      ))}
    </RadioGroup>
  )
}, "RarityFilter")
